<template>
    <div class="kits-list">
        <KitHeader
        :title="$root.t('Kits de acessórios')"
        :subtitle="$root.t('Treine Em Casa com a Smart Fit!')"
        :description="$root.t('Reunimos os nossos parceiros para que você treine com o que há de melhor no mercado fitness. Compre direto do fornecedor, tenha descontos exclusivos e receba em casa.')"></KitHeader>

        <div class="container">
            <div class="row mb-4" v-for="category in kitsCategories" :key="category">
                <div class="col-md-12" v-if="kits[category].kits && kits[category].kits.length">
                    <h3 class="section-title underline" v-html="kits[category].title"></h3>
                </div>

                <div class="col-md-4 mb-4" v-for="kit in kits[category].kits" :key="kit.ID">
                    <KitCard :category="category" :kit="kit"></KitCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import KitHeader from '@/components/KitHeader'
import KitCard from '@/components/KitCard'

export default {
    components : { KitHeader, KitCard },
    computed : {
        ...mapGetters([
            'kits',
            'kitsCategories'
        ]),
    },
    methods : {
        ...mapActions({
            getKits : 'getKits'
        })
    },
    created () {
        this.getKits()
    }
}
</script>

<style>

</style>